import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { useEffect, useState, useCallback, FormEvent } from 'react';

import { useAppDispatch, useAppSelector } from '@/redux';
import { redirectPayjunctionCsrClear } from '@/redux/slices/cart.slice';
import { LoggerService } from '@/services';
import { loadPaymentProvider } from '@/redux/thunks/checkout/loadPaymentProvider';
import { LOG_MSG, LOG_URL } from '@/constants/logger';
import { PAYJUNCTION_RESPONSE_CODES, PAYMENT_PLATFORMS } from '@/constants/checkout';

export const PayjunctionCsrTransactionId = ({ t }) => {
  const dispatch = useAppDispatch();

  const cart = useAppSelector(({ cart }) => cart.content);
  const userId = useAppSelector(({ user }) => user.content._id);
  const storeId = useAppSelector(({ root }) => root.storeConf.storeId);

  const router = useRouter();

  useEffect(() => {
    dispatch(loadPaymentProvider({ paymentProvider: PAYMENT_PLATFORMS.CSR_PAY_JUNCTION }));
    LoggerService.sendLog(cart.id, LOG_MSG.PAYJUNCTION.FORM, storeId, LOG_URL.PAYJUNCTION_FORM, userId, cart);
  }, []);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.target as HTMLFormElement);
    const transactionId = formData.get('transactionId');
    await router.push(
    `/payjunction?cartId=${cart.id}&response_code=${PAYJUNCTION_RESPONSE_CODES.APPROVED}&tracking_code=${transactionId}`
    );
  };

  return (
    <>
      <label>{t('checkout:payMode.payjunctionTransactionId')}</label>
      <form onSubmit={(event) => handleSubmit(event)} id="payjunction-csr-form">
        <input type="text" name={'transactionId'} data-test-id="payjunction-csr-transactionid-input" />
      </form>
      <div>
        {t('checkout:payMode.cartId')} {cart.id}
      </div>
    </>
  );
};

PayjunctionCsrTransactionId.propTypes = {
  t: PropTypes.func.isRequired
};

export default PayjunctionCsrTransactionId;
